
//WPF TO JS
// var synapse = {};
// synapse.callJSFromClient = callJSFromClient;
// function callJSFromClient(message,data){
//     console.log(`You are calling: ${arguments.callee.name}`,message,data);
// }
// //JS TO WPF
// synapse.callWPFFromJS = callWPFFromJS;
// function callWPFFromJS(message,data){
//     if (typeof callbackObj != "undefined"){
//         callbackObj.passData(message, data);
//     }
//     console.log(`You are calling: ${arguments.callee.name}`,message,data);
// }

// export default window.synapse;

import AVS from './../lib/AVS'
import Wrapper from './../utils/AVSWrapper'
import { AlexaCommon } from './../utils/Common'
import AlexaWebServiceContext from 'settings/AlexaWebService.json'

export class SynapseMessenger {

    static wrapper;
    callbackObj = {};

    //use this window.avs

    static AddEvents() {
        window.avs.on(AVS.EventTypes.RECORD_START, () => {
            if (typeof window.callbackObj != "undefined")
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.RECORD_START);
        });
        window.avs.on(AVS.EventTypes.RECORD_STOP, () => {
            if (typeof window.callbackObj != "undefined")
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.RECORD_STOP);
        });
        window.avs.on(AVS.EventTypes.SPEAKING, () => {
            if (typeof window.callbackObj != "undefined")
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.SPEAKING);
        });
        window.avs.on(AVS.EventTypes.NO_RESPONSE, () => {
            if (typeof window.callbackObj != "undefined")
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.NO_RESPONSE);
        });
        window.avs.on(AVS.EventTypes.LOGIN, () => {
            if (typeof window.callbackObj != "undefined") {
                console.log('emitting login event to wpf');
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.REFRESH_PAGE);
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.LOGIN);
            }
        });
        window.avs.on(AVS.EventTypes.LOGOUT, () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.REFRESH_PAGE);
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.LOGOUT);
            }
        });
        window.avs.on(AVS.EventTypes.MIC_OFF, () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.MIC_OFF);
            }
        });
        window.avs.on(AVS.EventTypes.NO_MIC, () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.NO_MIC);
            }
        });
        window.avs.on(AVS.EventTypes.SHOW_CARD, (payload) => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSResponse", JSON.stringify(payload));
            }
        });
        window.avs.on(AVS.EventTypes.FINISH_SPEAK, () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.FINISH_SPEAK);
            }
        });
        window.avs.on(AVS.EventTypes.TOKEN_INVALID, () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.TOKEN_INVALID);
            }
        });
        window.avs.on(AVS.EventTypes.TOKEN_SET, () => {
            if (typeof window.callbackObj != "undefined") {                
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.TOKEN_SET);
            }
            if (typeof SynapseMessenger.setToBE !== "undefined" && window.location.href.indexOf("?page=home") > -1) {
                SynapseMessenger.setToBE(`AVSToken`, JSON.stringify(localStorage.getItem('token')));
            }
        })
        window.avs.on(AVS.EventTypes.REFRESH_TOKEN_SET, () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.REFRESH_TOKEN_SET);
            }
        })
        window.avs.on(AVS.EventTypes.AUTHENTICATED_SUCCESS, () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.AUTHENTICATED_SUCCESS);
            }
        });
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_SYNAPSE_DATA, "1", () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.GET_ALEXA);
            }
        });

        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_SWAP_AUDIO_STREAM, "1", (currentDeviceId) => {
            if (typeof window.callbackObj != "undefined") {
                //TODO
                //PLEASE CALL avsWrapper swapAudioContextStreamFromHTML function after WPF receive this event.
                //Please set currentDeviceId as parameter to swapAudioContextStreamFromHTML.
            }
        });
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_THEME, "1", () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.GET_THEME);
                AlexaCommon.consoleLogDataToSynpase("Request Theme event passed to Synapse", window.rzevent.EventTypes.REQUEST_THEME);
            } else {
                AlexaCommon.consoleLogDataToSynpase("window.callbackObj was not intialized", window.rzevent.EventTypes.REQUEST_THEME);
            }
        });
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_LANGUAGE, "1", () => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.GET_LANGUAGE);
            }
        });
        window.avs.on(AVS.EventTypes.EXPECT_SPEECH, (speechDirective) => {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSExpectSpeech", JSON.stringify(speechDirective));
            }
        });
        /**
         * @event window.rzevent.EventTypes.SYNAPSE_STATUS_CHANGE
         * @param {boolean} status
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.SYNAPSE_STATUS_CHANGE, "1", (status) => {
            if (typeof SynapseMessenger.setToBE !== "undefined") {
                let synapseStr = AlexaCommon.makeSynapseStringValueOnlyFromJsonObj({ [AlexaWebServiceContext.Enable_Key]: status });
                SynapseMessenger.setToBE(AlexaWebServiceContext.RazerSkill_Feature_Key, synapseStr);
            }
        });
        /**
         * @event window.rzevent.EventTypes.ALEXA_ENABLE_CHECKED
         * @param {boolean} status
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.ALEXA_ENABLE_CHECKED, "1", (status) => {
            if (typeof SynapseMessenger.setToBE !== "undefined") {
                let synapseStr = AlexaCommon.makeSynapseStringValueOnlyFromJsonObj({ [AlexaWebServiceContext.Enable_Key]: status });
                SynapseMessenger.setToBE(AlexaWebServiceContext.ApplicationSetting_Feature_Key, synapseStr);
                //also sent SPEAKING event to let WPF close popup and rollback anything that currently doing.
                SynapseMessenger.wrapper.cancelRecording();
            }
        });
         /**
         * @event window.rzevent.EventTypes.APP_SOUNDS_CHECKED
         * @param {boolean} status
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.APP_SOUNDS_CHECKED, "1", (status) => {
            if (typeof SynapseMessenger.setToBE !== "undefined") {
                let synapseStr = AlexaCommon.makeSynapseStringValueOnlyFromJsonObj({ [AlexaWebServiceContext.Enable_Key]: status });
                SynapseMessenger.setToBE(AlexaWebServiceContext.ApplicationSound_Feature_Key, synapseStr);
            }
        });
         /**
         * @event window.rzevent.EventTypes.DISPLAY_CARDS_CHECKED
         * @param {boolean} status
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.DISPLAY_CARDS_CHECKED, "1", (status) => {
            if (typeof SynapseMessenger.setToBE !== "undefined") {
                let synapseStr = AlexaCommon.makeSynapseStringValueOnlyFromJsonObj({ [AlexaWebServiceContext.Enable_Key]: status });
                console.log(AlexaWebServiceContext.DisplayCardLayout_Feature_Key);
                SynapseMessenger.setToBE(AlexaWebServiceContext.DisplayCardLayout_Feature_Key, synapseStr);
            }
        });

        /**
         * @event window.rzevent.EventTypes.RAZER_TOPIC_ID 
         * @param {string} topicId
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.RAZER_TOPIC_ID,"1", (topicId) =>{
            if (typeof SynapseMessenger.setToBE !== "undefined") {
                SynapseMessenger.setToBE(AlexaWebServiceContext.RazerTopicId_Feature_Key, topicId);
            }
        })

        /**
         * @event window.rzevent.EventTypes.REQUEST_SYNAPSE_TOKEN
         * @description
         * request synapse token when HTML side is ready.
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_SYNAPSE_TOKEN,"1",()=>{
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", window.rzevent.EventTypes.REQUEST_SYNAPSE_TOKEN);
            }
        });

        /**
         * @todo  HTTP/2 and maybe need websocket here.
         */
        window.avs.on(AVS.EventTypes.TEST_AUDIO_BUFFER, (dataview) => {
       //     AlexaCommon.nodeCallTestAudioBuffer(dataview, SynapseMessenger.wrapper.avs.token);
        });

        /**
         * @description
         * It will be called when checkbox changes in settings page.
         * @event window.rzevent.EventTypes.REQUEST_ENABLE_WAKEWORD_STATUS_CHANGE
         * 
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_ENABLE_WAKEWORD_STATUS_CHANGE, "1", (data)=>{
            if (typeof SynapseMessenger.setToBE !== "undefined") {
                
                console.log(data);
                this.setToBE('WakeWord', JSON.stringify(data));
            }
        });

         /**
         * @description
         * It will be called when checkbox changes in settings page.
         * @event window.rzevent.EventTypes.REQUEST_ENABLE_SHORTCUT_STATUS_CHANGE
         * 
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_ENABLE_SHORTCUT_STATUS_CHANGE, "1", (data)=>{
            if (typeof SynapseMessenger.setToBE !== "undefined") {
                console.log(data);
                this.setToBE('KeyboardShortcut', JSON.stringify(data));
            }
        });

        /**
         * @description
         * Notice WPF to add overlay for wpf modules when dialog needs to be opened.
         * @event window.rzevent.EventTypes.REQUEST_SHOW_ACCOUNT_LINK_CONFLICTS_DIALOG
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_SHOW_ACCOUNT_LINK_CONFLICTS_DIALOG, "1", (data)=>{
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", window.rzevent.EventTypes.REQUEST_SHOW_ACCOUNT_LINK_CONFLICTS_DIALOG);
            }
        });
          /**
         * @description
         * Notice WPF to remove overlay for wpf modules when dialog needs to be closed.
         * @event window.rzevent.EventTypes.REQUEST_CLOSE_ACCOUNT_LINK_CONFLICTS_DIALOG
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_CLOSE_ACCOUNT_LINK_CONFLICTS_DIALOG, "1", (data)=>{
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", window.rzevent.EventTypes.REQUEST_CLOSE_ACCOUNT_LINK_CONFLICTS_DIALOG);
            }
        });

        /**
         * @description
         * Notice WPF AmazonRazerId once we get it from Skill Enablement API (AlexaCommon.retrieveAccountLinkingStatus)
         * @event window.rzevent.EventTypes.REQUEST_AMAZON_ID_FOR_SYNAPSE
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_AMAZON_ID_FOR_SYNAPSE, "1", (data)=>{
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSAmazonRazerId", data);
                AlexaCommon.consoleLogDataUIImportantInfo("WPF got AVSAmazonRazerId now",data);
            }
        });
        window.rzevent.listenEvent(window.rzevent.EventTypes.DO_LOGOUT, "1", (data)=>{
            if (typeof window.callbackObj != "undefined") {
                AlexaCommon.consoleLogDataUIImportantInfo("WPF got LOGOUT REQUEST now");
                window.callbackObj.onStatusChange("AVSStatus", window.rzevent.EventTypes.DO_LOGOUT);
            }
        });
        /**
         * @description
         * Notice WPF new access token has been set because the concequence of calling @function useRefreshTokenToUpdateAccessToken in 
         * AVSWrapper.js.
         */
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_TELL_WPF_NEW_ACCESS_TOKEN, "1", (data)=>{
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("TellWPFNewToken", data);
                AlexaCommon.consoleLogDataUIImportantInfo("WPF got new Token notice now",data);
            }
        });

        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_WRAPPER_IS_READY, "1", (data)=>{
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSStatus", window.rzevent.EventTypes.REQUEST_WRAPPER_IS_READY);
                AlexaCommon.consoleLogDataUIImportantInfo("WPF knows wrapper is ready now",data);
            }
        });
        window.rzevent.listenEvent(window.rzevent.EventTypes.REQUEST_IS_ALLOW_WAKE_WORD_STATUS_CHANGE, "1", ()=>{
            console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AskWPFIsAllowWakeWordChange", window.rzevent.EventTypes.REQUEST_IS_ALLOW_WAKE_WORD_STATUS_CHANGE);
                AlexaCommon.consoleLogDataUIImportantInfo("Ask WPF to give is allow wake word status change");
            }
        });
        window.rzevent.listenEvent(window.rzevent.EventTypes.OPEN_URL, "1", (data)=>{
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange(window.rzevent.EventTypes.OPEN_URL, data);
                AlexaCommon.consoleLogDataUIImportantInfo("SYNAPSE OPEN url",data);
            }
        });
    }


    static callJSFromClient(message, data) {
        console.log(message + " " + data);
        if (message == "start") {
            SynapseMessenger.wrapper.startRecording();
        }
        else if (message == "cancel") {
            SynapseMessenger.wrapper.cancelRecording();
        }
        else if (message == "stop") {
            SynapseMessenger.wrapper.stopRecording();
        }
        else if (message == "clearHash") {
            SynapseMessenger.wrapper.clearURLHash();
        }
        else if (message == "refreshCards") {
            SynapseMessenger.wrapper.triggerRefreshCardEvent();
        }
        else if (message == "getToken") {
            if (typeof window.callbackObj != "undefined") {
                window.callbackObj.onStatusChange("AVSToken", JSON.stringify(localStorage.getItem('token')));
            }
        }
        else if (message == "stopPlay") {
            SynapseMessenger.wrapper.stopPlay();
        }
        else if (message == "trylogin") {
            SynapseMessenger.wrapper.login();
        }
        else if (message == "navigateTo") {
            SynapseMessenger.wrapper.navigateTo(data);
        }
        else if (message == "logout") {
            SynapseMessenger.wrapper.logout();
        }
        else if (message == "setShortcut") {
            SynapseMessenger.wrapper.setShortcut(data);
        }
        else if (message == "alexaJson") {
            AlexaCommon.consoleLogDataFromSynpase("Call from Synapse , alexaJson", JSON.stringify(data));
            SynapseMessenger.wrapper.setalexaJson(data);
        }
        else if (message == "refreshToken") {
            SynapseMessenger.wrapper.useRefreshTokenToUpdateAccessToken();
        }
        else if (message == "setToken") {
            SynapseMessenger.wrapper.setToken();
        }
        else if (message == "theme") {
            SynapseMessenger.wrapper.setTheme(data);
        }
        else if (message == "language") {
            SynapseMessenger.wrapper.setLanguage(data);
        }
        else if (message == "deviceUpdate") {
            SynapseMessenger.wrapper.deviceChanged();
        }
        else if (message == "swapDevice") {
            console.log("swap device:"+ data);
            //SynapseMessenger.wrapper.swapAudioContextStreamFromWPF(data);
        }
        else if (message == "setSynapseToken") {
            SynapseMessenger.wrapper.setSynapseToken(data);
        }
        else if (message == "guestInfo"){
            console.log("guestInfo:"+ data);
            SynapseMessenger.wrapper.setSynapseIsGuestStatus(data);
        }
        else if (message == "closeNotificationDialog") {
            SynapseMessenger.wrapper.forceCloseAllNotificationDialog();
        }else if (message == "wakeWordStatusCHange"){
            SynapseMessenger.wrapper.changeWakeWordStatus(data);
        }else if (message == "AudioDevice"){
            SynapseMessenger.wrapper.updateAudioDeviceDropDownEnableStatus(data);
        }
        else if (message == "sendWakeWordAudio") {
            SynapseMessenger.wrapper.sendWakeWordAudio(data);
        }
        if (message == "changeEndPoint") {   //data = dev or staging or prod
           
        }
    }

    static Initialize() {
        if (typeof window.synapse !== "undefined") {
            window.synapse.callJSFromClient = this.callJSFromClient;
            this.wrapper = new Wrapper(window.avs);
            this.AddEvents();
        }
       
    }

    static tryLogIn() {
        if (typeof window.callbackObj != "undefined") {
            window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.TRY_LOGIN);
        }
    }

    static refreshPage() {
        if (typeof window.callbackObj != "undefined") {
            window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.REFRESH_PAGE);
        }
    }

    static getShortcut() {
        if (typeof window.callbackObj != "undefined") {
            window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.GET_SHORTCUT);
        }
    }

    static requestIsAllowWakeWordStatusChange(){
        if (typeof window.callbackObj != "undefined") {
            window.callbackObj.onStatusChange("AskWPFIsAllowWakeWordChange", window.rzevent.EventTypes.REQUEST_IS_ALLOW_WAKE_WORD_STATUS_CHANGE);
        }
    }

    /**
     * @param {string} feature
     * @example 
       [feature]:[data]
       "Language":
       "DoNotDisturb": 
       "AudioDevice": 
       "HotKey": "{"hotkey":"2|65"}",
       "RazerSkill": "{"enable":true}",
       "ApplicationSound": "{"enable":true}",
       "ApplicationSetting": "{"enable": true}"
       "DisplayCardLayout": "{"enable": true}"
       "WakeWord": "{"enable": true}"
       "KeyboardShortcut": "{"enable": true}"
     * 
     * @param {*} data
     */
    static setToBE(feature, data) {
        if (typeof window.callbackObj != "undefined") {
            window.callbackObj.onSet(feature, data);
        }
    }

    static GuestLogin(){
        if (typeof window.callbackObj != "undefined") {
            window.callbackObj.onStatusChange("AVSStatus", AVS.EventTypes.LOGIN_GUEST);
        }
    }
}
